module.exports = __webpack_public_path__ + "mc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/mc.svg
// module id = 932
// module chunks = 0